// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_2E3aK","hidden":"_3_a28","overlay":"_3gn0h","active":"_1j9Tl","poster":"_2TZ0L","icon":"_2t51W","transparency":"_2dUDj"};